import React, { useEffect, useState } from "react";
import { Button, Modal, Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import Select from "react-select";
import styles from "./PublicResult.module.css";
import { customStyles } from "../../../../../pages/customStyles";
import { AxiosInstance } from "../../../../../axios";
import toast from "react-hot-toast";
import { multiCusutomStyle } from "../../../../../pages/Multicustomstyles";

function DescriptivePublicResults({
  showDOpModel,
  handleClose_descriptive,
  batch_id,
  event_id,
  userid,
  handleflagReload,
  puBResult,
}) {
  const [detailsPuResult, setDetailsPuResult] = useState({
    is_combined: null,
    test_name: "",
    combined_tst: [],
  });

  const [testEvent, setTestEvent] = useState([]);

  useEffect(() => {
    AxiosInstance.get("api/test/descriptive/combined_event_name")
      .then((res) => {
        const TEEVENT = res.data.data.map((item, index) => ({
          value: item.id,
          label: item.name,
          id: item.id,
          name: item.name,
        }));
        setTestEvent(TEEVENT);
      })
      .catch((error) => {
        return error;
      });
  }, []);

  // Separate error messages for each input
  const [error, setError] = useState({});
  // radio field onchange

  const handleRadioChange = (e) => {
    const { name, value, checked } = e.target;

    if (name === "is_combined") {
      if (checked) {
        if (value === "0") {
          setDetailsPuResult({
            is_combined: "0",
            test_name: "",
            combined_tst: [],
          });
          setError({
            ...error,
            [name]: "",
          });
        } else {
          setDetailsPuResult({
            ...detailsPuResult,
            [name]: value,
          });
          setError({
            ...error,
            [name]: "",
          });
        }
      } else {
        setDetailsPuResult({
          ...detailsPuResult,
          [name]: "",
        });
      }
    } else {
      setDetailsPuResult({
        ...detailsPuResult,
        [name]: value,
      });
      setError({
        ...error,
        [name]: "",
      });
    }
  };

  const handleSelectTestChange = (selectedOption) => {
    setDetailsPuResult({
      ...detailsPuResult,
      ["combined_tst"]: selectedOption,
    });
    setError({
      ...error,
      ["combined_tst"]: "",
    });
  };

  // validate functionality
  const validatePublishResult_des = (data) => {
    const errors = {};
    if (data.is_combined === null) {
      errors.is_combined = "please select is combined test or not";
    } else if (data.test_name === "" && data.is_combined === "1") {
      errors.test_name = "please enter test name";
    } else if (data.combined_tst.length === 0 && data.is_combined === "1") {
      errors.combined_tst = "Please select other test name";
    }
    return errors;
  };

  // handle publish result

  const handlePublish = () => {
    const errorss = validatePublishResult_des(detailsPuResult);

    if (Object.keys(errorss).length === 0) {
      if (detailsPuResult.is_combined === "1") {
        const createPublishResults = {
          batch_id: batch_id,
          event_id: event_id,
          combine_name: detailsPuResult.test_name,
          combined_id:
            detailsPuResult.combined_tst.length > 0
              ? detailsPuResult.combined_tst.map((op) => op.id)
              : [],
          is_combined: 1,
        };
        AxiosInstance.post(
          "api/test/publish/results",
          createPublishResults
        ).then((res) => {
          if (res.data.status === true) {
            toast.success(res.data.message);
            handleClose_descriptive();
            handleflagReload();
          } else {
            toast.error(res.data.message);
          }
        });
      } else {
        const createPublishResults = {
          batch_id: batch_id,
          event_id: event_id,
          combine_name: "",
          combined_id: [],
          is_combined: 0,
        };
        AxiosInstance.post(
          "api/test/publish/results",
          createPublishResults
        ).then((res) => {
          if (res.data.status === true) {
            toast.success(res.data.message);
            handleClose_descriptive();
            handleflagReload();
          } else {
            toast.error(res.data.message);
          }
        });
      }
    } else {
      setError(errorss);
    }
  };

  return (
    <div>
      <Modal
        show={showDOpModel}
        onHide={handleClose_descriptive}
        size="lg"
        centered
      >
        <Modal.Header closeButton onClick={handleClose_descriptive}>
          <Modal.Title>
            <h5 className={`${styles.view_title} mb-0`} id="exampleModalLabel">
              Publish Results
            </h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row global_container">
            <div className="col-12">
              <form className="row g-3">
                {/* Conditional rendering based on is Published */}
                {!puBResult ? (
                  <>
                    {/* Radio button to check if it's a combined test */}
                    <div className="col-md-6">
                      <label
                        htmlFor="examName"
                        className="form-label confirm_value"
                      >
                        Is this a combined test?
                      </label>
                      <div>
                        <input
                          type="radio"
                          checked={
                            detailsPuResult.is_combined === "1" ? true : false
                          }
                          id="yes"
                          name="is_combined"
                          value="1"
                          className={styles.checkbox_radio}
                          onChange={handleRadioChange}
                        />
                        <label
                          htmlFor="yes"
                          className={`${styles.margin_right} form-label confirm_value`}
                        >
                          Yes
                        </label>
                        <input
                          type="radio"
                          id="no"
                          name="is_combined"
                          value="0"
                          checked={
                            detailsPuResult.is_combined === "0" ? true : false
                          }
                          className={styles.checkbox_radio}
                          onChange={handleRadioChange}
                        />
                        <label
                          htmlFor="no"
                          className="form-label confirm_value"
                        >
                          No
                        </label>
                      </div>
                      {/* Error message for radio input */}
                      {error.is_combined && (
                        <p className="text-danger input-font-size">
                          {error.is_combined}
                        </p>
                      )}
                    </div>

                    {/* Show the inputs initially, but hide them if "No" is selected */}
                    {detailsPuResult.is_combined === "1" && (
                      <>
                        {/* Combined Test Name */}
                        <div className="col-md-6">
                          <label
                            htmlFor="test_name"
                            className="form-label confirm_value"
                          >
                            Combined Test Name
                          </label>
                          <input
                            type="text"
                            name="test_name"
                            placeholder="Combined Test Name"
                            className={`${styles.border_head_color} form-control form-control-sm shadow-none input-font-size`}
                            id="test_name"
                            value={detailsPuResult.test_name}
                            onChange={handleRadioChange}
                          />
                          {/* Error message for Combined Test Name */}
                          {error.test_name && (
                            <p className="text-danger input-font-size">
                              {error.test_name}
                            </p>
                          )}
                        </div>

                        {/* Choose other tests to combine */}
                        <div className="col-md-6">
                          <label
                            htmlFor="chooseTest"
                            className="form-label confirm_value"
                          >
                            Choose other tests to combine
                          </label>
                          <Select
                            className="shadow-none input-font-size"
                            placeholder="Choose Test"
                            isMulti
                            isClearable
                            name="combined_tst"
                            options={testEvent}
                            closeMenuOnSelect={false}
                            value={detailsPuResult.combined_tst}
                            onChange={(option) =>
                              handleSelectTestChange(option)
                            }
                            styles={multiCusutomStyle}
                          />
                          {error.combined_tst && (
                            <p className="text-danger input-font-size">
                              {error.combined_tst}
                            </p>
                          )}
                        </div>
                      </>
                    )}
                  </>
                ) : (
                  <>
                    {/* Once published, show the combined test details */}
                    <div className="mt-3 col-md-6">
                      <div className="d-flex flex-column mt-2">
                        <p className="confirm_label mb-1 p-0">
                          Combined Test Name
                        </p>
                        <p className="confirm_value m-0 p-0">
                          {detailsPuResult.test_name}
                        </p>
                      </div>
                    </div>
                    <div className="mt-3 col-md-6">
                      <div className="d-flex flex-column mt-2">
                        <p className="confirm_label mb-1 p-0">
                          Other Combined Tests
                        </p>
                        <p className="confirm_value m-0 p-0">
                          Combined Test 01 - Paper 01, <br /> Combined Test 01 -
                          Paper 02
                        </p>
                      </div>
                    </div>
                  </>
                )}
              </form>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Link
            className={styles.cancel_button}
            data-bs-dismiss="modal"
            to="javascript:void(0)"
            onClick={handleClose_descriptive} // Close modal when clicking "Back to View Test"
          >
            Back to View Test
          </Link>
          {!puBResult && (
            <Button
              className={`${styles.DashboardButton}`}
              onClick={handlePublish}
              type="button"
            >
              Publish Now
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default DescriptivePublicResults;
